import { FC } from 'react';

import Head from 'next/head';

export const Title: FC = ({ children }) => (
  <Head>
    <title>{children}</title>
  </Head>
);
